import { createSlice } from "@reduxjs/toolkit";
import { DrawerState } from "./type";
import { RootState } from "store/rootReducer";

const initialState: DrawerState = {
  isToggled: false,
};

const drawer = createSlice({
  name: "drawerSlice",
  initialState,
  reducers: {
    setTogglePressed(state, action) {
      state.isToggled = action.payload;
    },
  },
});
export const { setTogglePressed } = drawer.actions;
export const selectIsToggled = (state: RootState) => state.drawer.isToggled;

export default drawer.reducer;
